import {
	/* DEFAULT_MEDIA_QUERY_PLATFORMS, */
	COMPONENT_TYPE as TYPE,
	LAYER_TYPE,
	COMPONENT_DISPLAY_NAME,
} from 'common/constants';
import { generateElementId, generateNodeId } from 'utils/generate-id';
import View from 'client/components/common/BuildingBlocks/FloatBelow/FloatBelow';

export const FLOAT_BELOW = () => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.FLOAT_BELOW;

			return {
				_id,
				type,
				uiConfig: {
					layer: LAYER_TYPE.CONTENT,
					editorProps: {
						name: COMPONENT_DISPLAY_NAME[type],
						selectable: false,
						draggable: false,
						expandable: true,
						expanded: true,
					},
					nodeProps: {
						id: generateNodeId(_id, 'flb'),
					},
					componentProps: {
						styles: {},
						other: {},
					},
				},
				children: [],
			};
		},
	};
};
